import { gql } from "@apollo/client";

const UnhideUserByTokenMutation = gql`
  mutation UnhideUserByTokenMutation($token: ID!) {
    unhideUserByToken(token: $token)
  }
`;

export default UnhideUserByTokenMutation;
